"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configCommissionApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var configCommissionApi = exports.configCommissionApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/configCommission",
      params: params
    });
  },
  init: function init(data) {
    return (0, _request.default)({
      url: "/configCommission/init",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/configCommission/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  }
};